import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-edit-document-context',
  templateUrl: './edit-document-context.component.html',
  styleUrls: ['./edit-document-context.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EditDocumentContextComponent implements OnInit {
  constructor(
    
  ) {
  }

  ngOnInit() {
    
  }
}
